export default {
  iframe_link:'',
  direct_line:'',
  facebook_access_token:'',
  external_analytics: '',
  external_analytics_second: '',
  queueNames:[],
  nlp: {

  },
  facebookConnector:{},
  licence_id: '',
  timeZoneShift: '',
}
